export enum TextAlign {
  Left = 'Left',
  Right = 'Right',
  Center = 'Center',
  Justify = 'Justify',
}

export enum ClipMode {
  EllipsisWithTooltip = 'EllipsisWithTooltip',
  Ellipsis = 'Ellipsis',
  Clip = 'Clip',
}
